import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 8h1v8","key":"svg-0"}],["path",{"d":"M13 8h4l-2 8","key":"svg-1"}]]

const IconNumber17Small = createReactComponent('outline', 'number-17-small', 'Number17Small', __iconNode);

export default IconNumber17Small;